import React from 'react';
import { connect } from 'react-redux';
import S from './phaseTaskBar.scss';
import PhaseType from 'types/phase';
import { deriveStatusName } from '../../../../../../utils';

const PhaseStatus = ({ phase: { status_name, source, workroom: { name: workroom = '' } = {} } }) =>
  <div className={S.phaseTaskBar__status}>
    <h5>Current Status</h5>
    <span className={S.statusText}>{deriveStatusName(status_name, { source, workroom })}</span>
  </div>;

PhaseStatus.propTypes = { phase: PhaseType.isRequired };

export default connect(state => ({ phase: state.phase.details }))(PhaseStatus);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/components/phaseStatus.jsx